import React, { useCallback, useState } from "react"

import clsxm from "@/lib/clsxm"
import type { Geolocation } from "@/lib/geolocation"
import { Routing } from "@/lib/routing"
import { Services } from "@/lib/services"

import { BookingSearch } from "@/components/Booking/BookingSearch"
import Heading from "@/components/common/Heading/Heading"

const Hero = () => {
  const [timeframe, setTimeframe] = useState(`next 7 days`)
  const [search, setSearch] = useState(``)
  const router = Routing.useRouter()
  const services = React.useContext(Services.Context)

  const onLocationResolve = useCallback(
    async ({
      address,
      position,
    }: {
      address: Geolocation.Bing.Address
      position: Geolocation.Position | void
    }) => {
      await router.push({
        pathname: `/booking`,
        query: {
          search: address.formattedAddress,
          specialty: services.selected,
          timeframe,
          ...(position ? { position } : {}),
        },
      })
    },
    [router, timeframe, services.selected]
  )

  return (
    <section
      className={clsxm(
        `flex justify-center bg-mint pt-[63px]  pb-14`,
        `md:pb-14`,
        `lg:py-36 lg:pb-10`
      )}
    >
      <div className={clsxm(`mx-4 w-full max-w-7xl`)}>
        <div className={clsxm(`m-auto mb-10 mt-10 max-w-6xl`, `sm:mt-20`)}>
          <Heading
            className={clsxm(
              `text-center font-baskervilleHeadings text-4xl font-bold tracking-tight`,
              `sm:text-7xl`
            )}
            headingLevel={`h1`}
          >
            Book immediate health and wellness appointments.
          </Heading>
        </div>
        <div id={`home-booking-search`} className={`m-auto w-full max-w-3xl`}>
          <BookingSearch
            onLocationResolve={onLocationResolve}
            onSearchChange={setSearch}
            onTimeframeChange={setTimeframe}
            searchValue={search}
            timeframeValue={timeframe}
          />
        </div>
      </div>
    </section>
  )
}

export default Hero
